import { useEffect, useState } from "react";
import { Globe2, Image as ImageIcon, FileText, ArrowUp } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function StickyScanBar() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const jumpTo = (tab) => {
    const scanner = document.querySelector('[data-testid="hero-scanner"]');
    if (scanner) scanner.scrollIntoView({ behavior: "smooth", block: "start" });
    setTimeout(() => {
      const el = document.querySelector(`[data-testid="tab-${tab}"]`);
      if (el) el.click();
    }, 400);
  };
  return (
    <div
      data-testid="sticky-scan-bar"
      className={`fixed top-0 left-0 right-0 z-40 transition-transform duration-300 ${visible ? "translate-y-0" : "-translate-y-full"}`}
    >
      <div className="bg-white/95 backdrop-blur border-b border-slate-200 shadow-sm">
        <div className="max-w-[1400px] mx-auto px-3 sm:px-6 md:px-8 py-2 sm:py-2.5 flex items-center gap-1.5 sm:gap-3 overflow-x-auto">
          <span className="hidden md:inline text-xs font-semibold text-slate-700 mr-2 whitespace-nowrap">
            {t("sticky.cta") || "Testez gratuitement :"}
          </span>
          <button onClick={() => jumpTo("site")} data-testid="sticky-tab-site"
            className="shrink-0 inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full bg-primary text-white text-[11px] sm:text-xs hover:bg-[hsl(var(--primary-light))]">
            <Globe2 className="w-3.5 h-3.5" /> <span>{t("tab.site") || "Mon site"}</span>
          </button>
          <button onClick={() => jumpTo("image")} data-testid="sticky-tab-image"
            className="shrink-0 inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full bg-slate-100 text-slate-700 text-[11px] sm:text-xs hover:bg-slate-200">
            <ImageIcon className="w-3.5 h-3.5" /> <span className="hidden xs:inline sm:inline">{t("tab.image") || "Image"}</span><span className="xs:hidden sm:hidden">Image</span>
          </button>
          <button onClick={() => jumpTo("document")} data-testid="sticky-tab-document"
            className="shrink-0 inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full bg-slate-100 text-slate-700 text-[11px] sm:text-xs hover:bg-slate-200">
            <FileText className="w-3.5 h-3.5" /> <span>{t("tab.document") || "Doc"}</span>
          </button>
          <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="sticky-scroll-top"
            className="ml-auto shrink-0 p-1.5 rounded-full text-slate-400 hover:text-primary hover:bg-slate-100" aria-label="Retour en haut">
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
